import * as Yup from "yup";

export const eventValidation = Yup.object({
  title: Yup.string().required("Title is required"),
  description: Yup.string().required("Description is required"),
  meetingLink: Yup.string().optional(),
  startDate: Yup.date().required("Start date is required"),
  startTime: Yup.string().required("Start time is required"),
  endDate: Yup.date().required("End date is required"),
  endTime: Yup.string().required("End time is required"),
});
